import { shopifyConfig } from '../data/shopify';
import type { CartLine } from '../types/cart';

export type PermalinkResult = { url: string | null; missing: string[] };

/** Builds a Shopify cart permalink. Returns missing config keys when not connected. */
export function buildCartPermalink(lines: CartLine[]): PermalinkResult {
  const missing = new Set<string>();
  if (!shopifyConfig.storeDomain) missing.add('storeDomain');
  const parts: string[] = [];

  for (const l of lines) {
    if (l.kind === 'individual') {
      const v = shopifyConfig.variantIds.individual;
      if (!v) missing.add('variantIds.individual');
      parts.push(`${v || '{individual}'}:${l.qty}`);
    } else {
      const v = shopifyConfig.variantIds[l.bundleId];
      if (!v) missing.add(`variantIds.${l.bundleId}`);
      parts.push(`${v || `{${l.bundleId}}`}:1`);
      if (l.extras > 0) {
        const a = shopifyConfig.variantIds.addon;
        if (!a) missing.add('variantIds.addon');
        parts.push(`${a || '{addon}'}:${l.extras}`);
      }
    }
  }

  const path = `/cart/${parts.join(',')}`;
  return {
    url: missing.size ? null : `https://${shopifyConfig.storeDomain}${path}`,
    missing: Array.from(missing),
  };
}

export function previewPermalinkPath(lines: CartLine[]) {
  const r = buildCartPermalink(lines);
  return r.url ?? `https://{store-domain}/cart/${lines.length ? '…' : ''}`;
}
